import React from "react";
import { useSelector } from "react-redux";
import MovieCard from "../movie/MovieCard";

const WishlistPage = () => {
  const items = useSelector((s) => s.wishlist.items);
  const movies = Object.values(items).sort((a, b) => b.addedAt - a.addedAt);

  return (
    <div className="container mt-4 mb-5">
      <h2 className="mb-1">
        <i className="fas fa-bookmark text-warning mr-2"></i>
        Wishlist
      </h2>
      <p className="text-muted mb-4">{movies.length} movies</p>

      {movies.length === 0 ? (
        <div className="empty-state">
          <i className="far fa-bookmark"></i>
          <h4>Wishlist is empty</h4>
          <p>Bookmark movies you want to watch someday.</p>
        </div>
      ) : (
        <div className="movie-grid">
          {movies.map((movie) => (
            <MovieCard key={movie.imdbID} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
};

export default WishlistPage;
